const initualState = {
  member: { data: null, currentPrice: null, fundName: null },
  nonMember: null,
  active: null
};

export default (state = initualState, action) => {
  switch (action.type) {
    case "SET_MEMBER_DASHBOARD_VALUES":
      return { ...state, member: action.payload };
    case "SET_NON_MEMBER_DASHBOARD_VALUES":
      return { ...state, nonMember: action.payload };
    case "SET_ACTIVE_DASHBOARD":
      return { ...state, active: action.payload };
    default:
      return state;
  }
};
